import { db } from '@/config'

function getRandomSimilars (similars) {
  const aux = []
  const iterator = [1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
  return iterator.map(i => {
    const item = similars[Math.floor(Math.random() * similars.length)]
    return item.id && db.doc(`programs/${item.id}`)
  }).filter((elem, pos, arr) => {
    return arr.findIndex(i => i.id === elem.id) == pos;
  })
}

export default getRandomSimilars
